<div class="flex">
  <div id="ad">

  </div>

  <div id="background">
    <mat-card>
      <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
        <h1>
          <img id="application-logo" width="480" class="sap-logo" title="SAP - Sistema de Avaliação Prática" src="/assets/img/logos/logo-sap-login.png">
        </h1>
        @if (nomeAmbiente) {
          <h2>Ambiente: {{nomeAmbiente}}</h2>
        }

        <label for="cpf">
          <p class="input-name">Digite seu CPF</p>
        </label>
        <div class="form-fields">
          <input id="cpf" [textMask]="{mask: mask.cpf}" class="background-input" name="cpf" formControlName="cpf" placeholder="">

          <br><br>

          <label for="password">
            <p class="input-name">Senha</p>
          </label>
          <input id="password" class="background-input" formControlName="password" name="password" type="password" placeholder="">

          <div>
            <button mat-raised-button class="login-btn center" color="primary" [disabled]="blockLoginBtn">
              @if (!blockLoginBtn) {
                <i>Entrar</i>
              }
              @if (blockLoginBtn) {
                <mat-spinner class="login-spinner" diameter="20"></mat-spinner>
              }
            </button>

            <div class="">
              <br>

                <span class="action-button-forgot" (click)="onForgotPassword()">Esqueci minha senha</span>
                <button type="button" id="self-registration-button" mat-raised-button class="register-btn center" color="primary" (click)="onRegister()">Cadastre-se aqui</button>

                <br>
                <!-- <div class="login-options" (click)="socialSignIn('google')">
                <img class="login-options-item" src="/assets/img/btns/google-login-btn.png">
              </div> -->
            </div>
          </div>
        </div>
      </form>
      <br>

      </mat-card>
    </div>
    <app-support-card></app-support-card>
  </div>
